import React from "react";

import { cn } from "../../../lib/utils";

export const STEP_BODY_CLASS = "min-h-0 flex-1 overflow-auto";

interface StepLayoutProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  bodyClassName?: string;
}

export function StepLayout({
  header,
  footer,
  children,
  bodyClassName,
}: StepLayoutProps) {
  return (
    <>
      {header ? <div className="flex-shrink-0">{header}</div> : null}
      <div className={cn(STEP_BODY_CLASS, bodyClassName)}>{children}</div>
      {footer ? <div className="flex-shrink-0 pt-6">{footer}</div> : null}
    </>
  );
}
